import React, { useCallback, useRef } from "react";
import { GeolocateControl as MapboxGeolocateControl } from "mapbox-gl";
import { useTranslation } from "react-i18next";
import { GeolocateControl, useMap } from "react-map-gl/mapbox-legacy";
import { MapboxButtonMimic } from "./MapboxButtonMimic";

export const GeolocationTool = ({
  geolocateClicked,
}: {
  geolocateClicked: () => Promise<void>;
}) => {
  const { t } = useTranslation();
  const { current: map } = useMap();
  const geolocateControlRef = useRef<MapboxGeolocateControl>(null);

  const handleClick = useCallback(async () => {
    await geolocateClicked();
    geolocateControlRef.current?.trigger();
  }, [geolocateClicked]);

  return (
    <>
      {/* Hidden GeolocateControl provides access to the trigger() method for
          activating browser geolocation. We render our own button via
          MapboxButtonMimic to control positioning. */}
      {map && (
        <GeolocateControl
          ref={geolocateControlRef}
          trackUserLocation
          fitBoundsOptions={{ maxZoom: 18, minZoom: 18 }}
          position="bottom-right"
          style={{ display: "none" }}
        />
      )}
      <MapboxButtonMimic
        showLabel
        buttons={[
          {
            iconClass: "mapboxgl-ctrl-geolocate",
            onClick: handleClick,
            label: t("button-show-location"),
          },
        ]}
      />
    </>
  );
};
